export default {
  name: "EmailDialogChangeType",
  data() {
    return {
      dialog: false,
      reject: null,
      message: null,
      outputMsg: "",
      title: null,
      resolve: null,
      hasTextField: false,
      textFieldLabel: "Note",
      options: {
        color: "#3f51b5",
        width: 605,
        zIndex: 200,
        noconfirm: false
      }
    }
  },
  methods: {
    open(title, message, hasTextField, textFieldLabel, options) {
      this.dialog = true;
      this.title = title;
      this.hasTextField = hasTextField;
      this.textFieldLabel = textFieldLabel;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve({ agree: true, message: this.outputMsg });
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

  }
}